module.exports = __webpack_public_path__ + "static/img/jygl613.67d9424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jygl613.png
// module id = UlAD
// module chunks = 73